export type ToastType = 'success' | 'error' | 'delete'

export interface ToastAction {
  label: string
  onClick: () => void
}

export interface ToastNotification {
  id: string
  message: string
  itemName?: string
  type?: ToastType
  duration?: number
  action?: ToastAction
}

type ToastListener = (toasts: ToastNotification[]) => void

class ToastStore {
  private toasts: ToastNotification[] = []
  private listeners = new Set<ToastListener>()

  subscribe(listener: ToastListener): () => void {
    this.listeners.add(listener)
    listener(this.toasts)
    return () => this.listeners.delete(listener)
  }

  push(notification: Omit<ToastNotification, 'id'>): string {
    const id = `toast_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
    const next = { id, ...notification }
    this.toasts = [next]
    this.emit()
    return id
  }

  dismiss(id: string): void {
    this.toasts = this.toasts.filter(t => t.id !== id)
    this.emit()
  }

  clear(): void {
    this.toasts = []
    this.emit()
  }

  private emit(): void {
    for (const listener of this.listeners) {
      listener(this.toasts)
    }
  }
}

export const toastStore = new ToastStore()
